import { Injectable } from '@angular/core';
import * as CryptoJS from 'crypto-js';
import { environment } from '@env/environment';

@Injectable({
  providedIn: 'root',
})
export class EncryptionService {
  generateRandomString(num: number) {
    const characters = environment.encryptionCharacters; // Fetch from environment

    let result = '';

    for (let i = 0; i < num; i++) {
      // Adjust the loop count to match the length of the target string minus '='
      result += characters.charAt(
        Math.floor(Math.random() * characters.length)
      );
    }

    return result + '=';
  }

  encrypt(data: string): string {
    var randomkey = this.generateRandomString(31);
    var randomiv = this.generateRandomString(15);

    var key = CryptoJS.enc.Utf8.parse(randomkey);

    var iv = CryptoJS.enc.Utf8.parse(randomiv);

    const encryptedData =
      randomkey +
      '$' +
      CryptoJS.AES.encrypt(data, key, { iv: iv }).toString() +
      '$' +
      randomiv;

    return encryptedData;
  }

  decrypt(data: string): string {
    
    if (!data) {
      // console.error('No data to decrypt');
      return '';
    }

    var splitString: string[] = data.split('$');

    const key = CryptoJS.enc.Utf8.parse(splitString[0]);
    const iv = CryptoJS.enc.Utf8.parse(splitString[2]);

    const decryptedData = CryptoJS.AES.decrypt(splitString[1], key, { iv: iv });
    return decryptedData.toString(CryptoJS.enc.Utf8);
  }

  encryptObject(data: any): string {
    if (data === null || data === undefined) {
      throw new Error('Cannot encrypt null or undefined data');
    }

    if (typeof data !== 'string') {
      data = JSON.stringify(data);
    }

    return this.encrypt(data); // Use the updated `encrypt` method
  }

  decryptObject(data: string): any {
    if (data === null || data === undefined) {
      throw new Error('Cannot decrypt null or undefined data');
    }

    const decryptedString = this.decrypt(data); // Use the updated `decrypt` method

    if (decryptedString) {
      try {
        return JSON.parse(decryptedString);
      } catch (error) {
        console.error('Error parsing decrypted object:', error);
        return null;
      }
    }
    return null;
  }

  decryptArray(data: any): any[] {
    if (data === null || data === undefined) {
      throw new Error('Cannot decrypt null or undefined data');
    }

    if (!Array.isArray(data)) {
      data = [data];
    }

    // return data
    //   .map((item: any) => {
    //     try {
    //       const decryptedString = this.decrypt(item); // Use updated `decrypt`
    //       return decryptedString ? JSON.parse(decryptedString) : null;
    //     } catch (error) {
    //       console.error('Error decrypting array item:', error);
    //       return null;
    //     }
    //   })
    //   .filter((item: any) => item !== null); // Remove any failed decryptions

    return data
      .map((item: any) => {
        try {
          const decryptedString = this.decrypt(item); // Use updated `decrypt`
          return decryptedString ? JSON.parse(decryptedString) : null;
        } catch (error) {
          console.error('Error decrypting array item:', error);
          return null;
        }
      })
      .filter((item: any) => item !== null) // Remove any failed decryptions
      .flat(); // Flatten the array if needed
  }
}
